export function isUnauthorizedError(error: any): boolean {
  const graphQLErrors = error?.response?.errors;
  if (!Array.isArray(graphQLErrors)) return false;
  return graphQLErrors.some(
    (err) => err.extensions?.code === "UNAUTHORIZED"
  );
}

export async function handleUnauthorizedError() {
  const callbackUrl = window.location.pathname ?? "/";
  const redirectUrl = `/sign-in?${new URLSearchParams({ callbackUrl }).toString()}`;
  
  window.location.href = redirectUrl;
  
  // eslint-disable-next-line @typescript-eslint/no-throw-literal
  throw new Promise(() => {});
}